import { useState } from "react";
import { faqs } from "@/mocks/quotes";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-50 py-16 md:py-24 scroll-mt-16">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-8 grid grid-cols-1 lg:grid-cols-5 gap-10">
        <div className="lg:col-span-2">
          <span className="text-xs tracking-widest text-primary-600 uppercase">FAQ</span>
          <h2 className="mt-3 font-heading text-2xl md:text-3xl font-semibold text-foreground-950">
            常见问题
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
            关于这个页面、这些文字，以及怎么用它们，你可能想知道的几个问题都在这里。
            点开任意一条就能看到回答。
          </p>
          <div className="mt-6 rounded-lg bg-accent-50 border border-accent-100 p-5">
            <p className="text-xs leading-relaxed text-foreground-700 flex items-start gap-2">
              <i className="ri-hand-heart-line text-accent-700 mt-0.5"></i>
              如果你长期情绪低落或出现伤害自己的念头，请一定联系身边信任的人或专业心理援助机构。
              文字可以陪你一会儿，但真正的支持更值得你去寻找。
            </p>
          </div>
        </div>

        <div className="lg:col-span-3 flex flex-col gap-3">
          {faqs.map((item, i) => {
            const isOpen = openIndex === i;
            return (
              <div
                key={item.q}
                className={`rounded-lg border transition-colors ${
                  isOpen ? "bg-background-100 border-primary-200" : "bg-background-100/60 border-background-200/70"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : i)}
                  aria-expanded={isOpen}
                  className="w-full flex items-center gap-4 text-left px-5 py-4 cursor-pointer"
                >
                  <span className="flex-1 font-heading text-sm md:text-base font-medium text-foreground-950">
                    {item.q}
                  </span>
                  <span
                    className={`shrink-0 w-7 h-7 flex items-center justify-center rounded-md text-foreground-600 transition-transform ${
                      isOpen ? "rotate-45 text-primary-700" : ""
                    }`}
                  >
                    <i className="ri-add-line"></i>
                  </span>
                </button>
                <div className={isOpen ? "block" : "hidden"}>
                  <p className="px-5 pb-5 text-sm leading-loose text-foreground-700">{item.a}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}